import {
  BaseActionObject,
  DoneInvokeEvent,
  StateNodeConfig,
  assign
} from "xstate4"
import { Context, Transitions } from "../types"
import { getServiceErrorMessage } from "../helpers"

export const editPublishedPlanTransition: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  exit: assign<Context>({ publishedStudyPlan: null }),
  invoke: {
    id: "buildPopulatedStudyPlan",
    src: "buildPopulatedStudyPlan",
    onDone: {
      target: "edit_plan",
      actions: assign((_ctx, evt) => ({
        studyPlan: evt.data.plan,
        // Collapse all sections when user enters edit state.
        expanded: []
      }))
    },
    onError: [
      {
        target: "#StudyPlan.study_plans_overview.idle",
        cond: (ctx, _evt) =>
          ctx.selfRefScope.scope === "DISTRICT" ||
          ctx.selfRefScope.scope === "SCHOOL",
        actions: assign<Context, DoneInvokeEvent<any>>({
          snackbar: (_ctx, evt) => ({
            message: getServiceErrorMessage("newPlan", {
              errorReason: evt.data.message,
              messageData: ["create a new plan"]
            }),
            withUndo: false,
            error: true
          })
        })
      },
      {
        target: "#StudyPlan.teacher_view.idle",
        cond: (ctx, _evt) => ctx.selfRefScope.scope === "TEACHER",
        actions: assign<Context, DoneInvokeEvent<any>>({
          snackbar: (_ctx, evt) => ({
            message: getServiceErrorMessage("newPlan", {
              errorReason: evt.data.message,
              messageData: ["create a new plan"]
            }),
            withUndo: false,
            error: true
          })
        })
      }
    ]
  }
}
